import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  title: {
    padding: 24,
    paddingTop: 32,
  },
  containerPaddingBottom: {
    paddingBottom: 24
  },
}));

export default styles;